const e=()=>{const e=new Date;return`${e.getTime()}${e.getMilliseconds()}`};export{e as n};
